<template>
  <div class="steptFour">
    <!-- 订单状态 -->
    <div class="orderStatus">
      <div class="orderStatus_left">
        <div class="orderStatus_icon">
          <i :class="orderStatus_iconText" :style="{color:orderStatus_iconTextColor}"></i>
        </div>
        <div class="orderStatus_con">
          <div class="orderStatus_statu" :style="{color:orderStatus_iconTextColor}">{{orderStatus_statuText}}</div>
          <div class="orderStatus_desc">
            <span v-if="orderStatu==1">请在<span class="timer">{{timerText}}</span>内完成支付, 超时后可重新生成二维码</span>
            <span v-if="orderStatu==2">我们将尽快安排发货，您可在“我的订单”中查看订单进度</span>
            <span v-if="orderStatu==3">二维码已失效，可点击二维码重新生成</span>
            <span v-if="orderStatu==4">订单已关闭，请您重新返回选择号码</span>
          </div>
        </div>
      </div>
      <div class="orderStatus_right">
        <div class="orderStatus_money" :style="{color:orderStatus_iconTextColor}">¥{{(totalMoney/100).toFixed(2)}}</div>
        <div class="orderStatus_morebtn cursor" @click="buyInfoShow">订单详情
          <i class="el-icon-arrow-up" v-if="orderInfoShow"></i>
          <i class="el-icon-arrow-down" v-else></i>
        </div>
      </div>
    </div>
    <!-- 购买信息 -->
    <div class="buyInfo" v-if="orderInfoShow">
      <div class="buyInfoLeft">
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">号码等级：</span><span class="buyInfoLeft_item_con">{{pretty}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">已选号码：</span><span class="buyInfoLeft_item_con">{{phone_number}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">归属地：</span><span class="buyInfoLeft_item_con">{{home}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">已选套餐：</span><span class="buyInfoLeft_item_con">{{package_msg}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">购卡人联系电话：</span><span class="buyInfoLeft_item_con">{{link_phone}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">收货信息：</span><span class="buyInfoLeft_item_con">{{post_name}} {{post_phone}} {{post_address}}</span></div>
      </div>
      <div class="buyInfoRight">
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">首月服务费：</span><span class="buyInfoRight_item_con">￥{{(card_money/100).toFixed(2)}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">套餐预存费：</span><span class="buyInfoRight_item_con">￥{{(prestore_money/100).toFixed(2)}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">首月服务费优惠：</span><span class="buyInfoRight_item_con">-￥{{((card_money - card_money_sale)/100).toFixed(2)}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">套餐预存费优惠：</span><span class="buyInfoRight_item_con">-￥{{((prestore_money - prestore_money_sale)/100).toFixed(2)}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">运费：</span><span class="buyInfoRight_item_con">￥{{(post_money/100).toFixed(2)}}</span></div>
        <div class="buyInfoLeft_item"><span class="buyInfoLeft_item_title">订单总计：</span><span class="buyInfoRight_item_con">￥{{(totalMoney/100).toFixed(2)}}</span></div>
      </div>
    </div>

    <!-- 支付模块 -->
    <div class="payBox">
      <div class="payLogo" v-if="orderStatu==1 || orderStatu==4">
        <img src="../../assets/wxpaylogo.png" alt="">
      </div>
      <div class="payCon">
        <!-- 未支付 -->
        <div class="payCon_item" v-if="orderStatu==1">
          <div class="payCode">
            <img :src="qrImg" alt="">
          </div>
          <div class="payCode_desc">
            <div>请使用<span style="color:#1989FA"> 微信 </span>扫一扫二维码</div>
            <div>完成支付</div>
          </div>
        </div>
        <!-- 已支付 -->
        <div class="payCon_item" v-if="orderStatu==2">
          <div class="ywLogo">
            <img src="../../assets/paysuccess.png" alt="">
          </div>
          <div class="pay_tip">支付成功</div>
          <div class="payCode_desc">
            <span class="lookOrder cursor" @click="gotoOrder">订单查询</span>
            <span class="continueBuy cursor" @click="gotoIndex">继续逛逛</span>
          </div>
        </div>
        <!-- 支付失败 -->
        <div class="payCon_item" v-if="orderStatu==3">
          <div class="payCode">
            <img src="../../assets/overtime.png" alt="">
          </div>
          <div class="payCode_desc">
            <span class="reBuy cursor" @click="repay">重新生成二维码</span>
          </div>
        </div>
        <!-- 已超时 -->
        <div class="payCon_item" v-if="orderStatu==4">
          <div class="payCode">
            <img src="../../assets/ywLogo.png" alt="">
          </div>
          <div class="payCode_desc">
            <span class="reBuy cursor" @click="gotoIndex">重新选号</span>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "stepFour",
  props: {
    orderid: String
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      orderStatu : 2, //
      orderStatus_iconText : 'el-icon-time',  //订单状态icon
      orderStatus_iconTextColor : '#1989FA',  //订单状态颜色
      orderStatus_statuText : '订单提交成功，去支付吧～',  //订单状态内容
      timer : 600, //未支付倒计时
      timerText : '10分0秒',
      timerFlag : false,   //倒计时开关
      orderInfoShow : false,  //购买详情展开收起
      qrImg : '',
      totalMoney : 0,
      pretty : '',
      phone_number : '',
      home : '',
      package_msg : '',
      link_phone : '',
      post_name : '',
      post_phone : '',
      post_address : '',
      card_money : 0,
      prestore_money : 0,
      card_money_sale : 0,
      prestore_money_sale : 0,
      post_money : 0,
      payResult : false,
      countdown : '',
      getPayResultTimer : ''
    }
  },
  methods: {
    Loading : function(text){
      this.loading = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    alertMsg : function(msg){
      this.$message({
        message: msg,
        type: 'error',
        offset: '300'
      });
    },
    buyInfoShow : function(){
      this.orderInfoShow = !this.orderInfoShow;
    },
    getOrderInfo : function(){
      var params = {
        "token": this.token,
        "sdk_order_id": this.orderid
      }
      var that = this;
      this.$http.post('/getOrderDetail',params,{emulateJSON: true})
      .then(function(res){ 
        that.loading.close();
        var data = res.data;
        console.log(data)
        if(data.code == '200'){
          that.totalMoney = parseInt(data.data.orderInfo.actualMoney);
          that.pretty = data.data.orderInfo.pretty == 1 ? "靓号" : "普号";
          that.phone_number = data.data.orderInfo.phoneNumber;
          that.home = data.data.orderInfo.cityName;
          that.package_msg = data.data.orderInfo.packageTitle;
          that.link_phone = data.data.orderInfo.linkPhone;
          that.post_name = data.data.postInfo.postName;
          that.post_phone = data.data.postInfo.postPhone;
          that.post_address = data.data.postInfo.postAddress;
          that.card_money = parseFloat(data.data.orderInfo.cardMoney);
          that.card_money_sale = parseFloat(data.data.orderInfo.cardMoneyActual);
          that.prestore_money = parseFloat(data.data.orderInfo.prestoreMoney);
          that.prestore_money_sale = parseFloat(data.data.orderInfo.prestoreMoneyActual);
          that.post_money = data.data.orderInfo.postCost;
          that.orderStatu = data.data.orderInfo.orderStatus; //1进行中2成功3失败4关闭    1进行中2已关闭3已支付4已制卡5已发货6已收货7已退货
          that.getPayInfo();
        }else{
          that.alertMsg(data.msg);
        }
      }).catch(function(err){ 
        that.loading.close();
        that.alertMsg('查询订单信息失败');
      })
    },
    getPayInfo : function(){
      var params = {
        "token": this.token,
        "sdk_order_id": this.orderid
      } 
      var that = this;
      this.$http.post('/toPay',params,{emulateJSON: true})
      .then(function(res){ 
        var data = res.data;
        console.log(data)
        if(data.code == '200'){
          that.loading.close();
          that.qrImg = data.data.qrImg;
          that.payTimer();
        }else{
          that.loading.close();
          that.alertMsg(data.msg);
          that.orderStatu = '4';
        }
      }).catch(function(err){ 
        that.loading.close();
        that.alertMsg('调取支付失败');
      })
    },
    payTimer : function(){
      this.timer = 600;
      this.timerText = '10分0秒';
      var that = this;
      this.countdown = setInterval(function(){
        if(that.timer <= 0){
          that.timer = 600;
          clearInterval(that.countdown);
          that.orderStatu = 3;
        }
        that.timer--;
        that.timerText = that.formatSeconds(that.timer);
      },1000)
      if(!this.payResult){
        this.payResult = true;
        // this.payresult();
      }
    },
    formatSeconds : function(value) {  
      var theTime = parseInt(value);// 秒  
      var theTime1 = 0;// 分   
      if(theTime > 60) {  
        theTime1 = parseInt(theTime/60);  
        theTime = parseInt(theTime%60);  
        if(theTime1 > 60) {   
          theTime1 = parseInt(theTime1%60);  
        }  
      }  
      var result = ""+parseInt(theTime)+"秒";  
      if(theTime1 > 0) {  
        result = ""+parseInt(theTime1)+"分"+result;  
      }  
      return result;  
    },
    repay : function(){
      this.orderStatu = '1';
      this.getPayInfo();
    },
    gotoIndex : function(){
      this.$emit('gotoStepOneFunc',0);
      this.payResult = false;
      clearInterval(this.getPayResultTimer);
    },
    gotoOrder : function(){
      this.$emit('gotoOrder','2');
      this.$router.push({path:`/order`})
      this.payResult = false;
      clearInterval(this.getPayResultTimer);
    }
  },
  beforeMount : function(){
    this.Loading('Loading...');
  },
  mounted:function(){
    this.getOrderInfo();
  },
  watch : {
    orderStatu : function(){
      if( this.orderStatu == 1 ){ //订单状态为未支付
        this.$emit('showStepFourFunc',3);
        this.orderStatus_iconText = 'el-icon-time';
        this.orderStatus_iconTextColor = '#1989FA';
        this.orderStatus_statuText = '订单提交成功，去支付吧～';
      }else if( this.orderStatu == 2 ){ //订单状态为已支付成功
        this.$emit('showStepFourFunc',4);
        this.orderStatus_iconText = 'el-icon-circle-check';
        this.orderStatus_iconTextColor = '#5CB87A';
        this.orderStatus_statuText = '恭喜您，支付成功！';
        this.timerFlag = false;
        this.timer = 600;
      }else if( this.orderStatu == 4 ){ //订单状态为已关闭
        this.$emit('showStepFourFunc',3);
        this.orderStatus_iconText = 'el-icon-circle-close';
        this.orderStatus_iconTextColor = '#F56C6C';
        this.orderStatus_statuText = '订单已关闭';
        this.timerFlag = false;
        this.timer = 600;
      }else if( this.orderStatu == 3 ){ //二维码超时
        this.$emit('showStepFourFunc',3);
        this.orderStatus_iconText = 'el-icon-time';
        this.orderStatus_iconTextColor = '#1989FA';
        this.orderStatus_statuText = '二维码已超时，请点击重新生成';
        this.timerFlag = false;
        this.timer = 600;
      }
    },
    payResult : function(){
      if(this.payResult){
        var that = this;
        that.getPayResultTimer = setInterval(function(){
          // if(that.payResult){
            var params = {
              "token": that.token,
              "sdk_order_id": that.orderid
            }
            that.$http.post('/payResult',params,{emulateJSON: true})
            .then(function(res){ 
              var data = res.data;
              if(data.code == '200'){
                if(data.data.result == '1'){  //1未支付 2支付成功 3支付失败 可重新生成二维码 4订单已关闭
                }else if(data.data.result == '2'){
                  clearInterval(that.getPayResultTimer);
                  that.orderStatu = '2';
                }else if(data.data.result == '3'){
                  that.orderStatu = '3';
                }else if(data.data.result == '4'){
                  clearInterval(that.getPayResultTimer);
                  that.orderStatu = '4';
                }
              }else if(data.code == '201'){
                //clearInterval(that.countdown);
                clearInterval(that.getPayResultTimer);
                that.alertMsg(data.msg)
              }
            }).catch(function(err){ 
              that.loading.close();
              that.alertMsg('查询支付结果失败');
            }) 
          // }
        },5000)
      }else{
        console.log('else')
        clearInterval(this.getPayResultTimer);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.getPayResultTimer); 
    this.timer = 600;
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.steptFour {
  text-align: left;
  .cursor {
    cursor: pointer;
  }
  .orderStatus {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 40px;
    border-bottom: 1px solid #E9E9E9;
    .orderStatus_left {
      display: flex;
      align-items: center;
      .orderStatus_icon {
        font-size: 48px;
        padding-right: 20px;
      }
      .orderStatus_con {
        .orderStatus_statu {
          color: #303133;
          font-size: 28px;
          font-weight:500;
          line-height: 45px;
        }
        .orderStatus_desc {
          color: #000000;
          font-size: 16px;
          .timer {
            color: #1989FA;
          }
        }
      }
    }
    .orderStatus_right {
      .orderStatus_money {
        color: #1989FA;
        font-size: 30px;
        font-weight:500;
        line-height: 45px;
      }
      .orderStatus_morebtn {
        color: #000000;
        font-size: 14px;
        text-align: right;
      }
    }
  }
  .buyInfo {
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    line-height: 30px;
    color: #909399;
    border-bottom: 1px solid #E9E9E9; 
    .buyInfoLeft {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      width: 70%;
      .buyInfoLeft_item {
        display: flex;
        .buyInfoLeft_item_title {
          min-width: 10%;
        }
        .buyInfoLeft_item_con {
          color: #303133;
          max-width: 80%;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;

        }
      }
    }
    .buyInfoRight {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .buyInfoLeft_item_title {
        display: inline-block;
        width: 160px;
        text-align: right;
      }
      .buyInfoRight_item_con {
        display: inline-block;
        width: 80px;
        color: #5CB87A;
        text-align: right;
      }
    }
  }
  .payBox {
    text-align: center;
    padding: 60px 0 120px;
    .payLogo {
      width: 210px;
      height: 50px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .payCon {
      padding-top: 40px;
      .payCon_item {
        .payCode {
          width: 210px;
          height: 210px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .ywLogo {
          width: 290px;
          height: 290px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .payCode_desc {
          padding-top: 40px;
          font-size: 26px;
          font-weight:500;
          color: #303133;
          .lookOrder {
            color: #606266;
            font-size: 18px;
            padding: 13px 20px;
            border:1px solid #DCDFE6;
            border-radius:6px;
            margin-right: 20px;
          }
          .continueBuy,.reBuy {
            color: #ffffff;
            background: #1989FA;
            font-size: 18px;
            padding: 13px 20px;
            border:1px solid ;
            border-radius:6px;
          }
        }
        .pay_tip {
          color: #606266;
          font-size: 24px;
        }
      }
    }
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
